
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { DesktopNavigation } from "./navbar/DesktopNavigation";
import { MobileNavigation } from "./navbar/MobileNavigation";
import { getNavigationData } from "./navbar/NavigationData";

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState<string | null>(null);
  
  const navigationData = getNavigationData();

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      setIsScrolled(scrollPosition > 10);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
    setOpenDropdown(null);
  };

  const toggleDropdown = (dropdown: string) => {
    setOpenDropdown(openDropdown === dropdown ? null : dropdown);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled 
          ? "bg-white shadow-md py-2" 
          : "bg-white py-4"
      }`}
    >
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center">
          <div className="flex items-center">
            <Link to="/" className="flex-shrink-0 flex items-center">
              <img 
                alt="Groupe Fabre Environnement Logo" 
                className="h-10 w-auto" 
                src="/lovable-uploads/01833d99-95a1-46a9-a9a1-1070eab97124.png" 
              />
            </Link>
          </div>

          <DesktopNavigation 
            openDropdown={openDropdown}
            toggleDropdown={toggleDropdown}
            {...navigationData}
          />

          <div className="lg:hidden">
            <Button
              variant="ghost"
              size="sm"
              className="text-fabre-gray"
              onClick={toggleMobileMenu}
            >
              {isMobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </Button>
          </div>
        </div>
      </div>

      <MobileNavigation 
        isMenuOpen={isMobileMenuOpen}
        toggleMenu={toggleMobileMenu}
        openDropdown={openDropdown}
        toggleDropdown={toggleDropdown}
        {...navigationData}
      />
    </header>
  );
};

export default Navbar;
